function getDiscountCode() {
  return "SUMMER25";
}

function getDiscountRatio() {
  const DISCOUNT_CODE = getDiscountCode();
  let ratio = 1;
  if (DISCOUNT_CODE === "SUMMER25") {
    ratio = 0.75;
  }
  return ratio;
}

function getDiscountCookie() {
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === "discount_code") {
      return value;
    }
  }
  return null;
}

async function applyBFDiscount() {
  console.log("applyBFDiscount");
  const DISCOUNT_CODE = getDiscountCode();

  try {
    await fetch(`/discount/${DISCOUNT_CODE}`);
  } catch (err) {
    console.error(err);
  }

  try {
    const { data } = await axios.get("/?sections=main-cart-items,cart-drawer");

    const mainCartItemsSection = new DOMParser().parseFromString(
      data["main-cart-items"],
      "text/html"
    );
    const cartDrawerSection = new DOMParser().parseFromString(
      data["cart-drawer"],
      "text/html"
    );

    const mainCart = document.querySelector("cart-items");
    const cartDrawer = document.querySelector("cart-drawer");

    if (mainCart) {
      mainCart.querySelector(".cart-items").innerHTML =
        mainCartItemsSection.querySelector(".cart-items").innerHTML;

      mainCart.querySelector(".cart__details .cart__summary").innerHTML =
        mainCartItemsSection.querySelector(
          ".cart__details .cart__summary"
        ).innerHTML;

      mainCart.querySelector(
        ".cart__details .special-offer__section"
      ).innerHTML = mainCartItemsSection.querySelector(
        ".cart__details .special-offer__section"
      ).innerHTML;

      mainCart.querySelector(
        ".cart__details .drawer-recommendations-section"
      ).innerHTML = mainCartItemsSection.querySelector(
        ".cart__details .drawer-recommendations-section"
      ).innerHTML;

      mainCart.querySelector(".cart__box-container").innerHTML =
        mainCartItemsSection.querySelector(".cart__box-container").innerHTML;

      mainCart.querySelector(".shipping-progress").innerHTML =
        mainCartItemsSection.querySelector(".shipping-progress").innerHTML;

      mainCart.querySelector(".progress-bar-container").innerHTML =
        mainCartItemsSection.querySelector(".progress-bar-container").innerHTML;
    }

    cartDrawer.querySelector(".drawer__inner").innerHTML =
      cartDrawerSection.querySelector("cart-drawer .drawer__inner").innerHTML;
  } catch (err) {
    console.error(err);
  }

  checkDiscountApplied();
  updateBFEarlyPricingDiscounts();

  // Ensure main product price is updated after cart updates
  setTimeout(() => {
    updateMainProductPrice();
  }, 200);
}

function setDiscountButton() {
  const DISCOUNT_CODE = getDiscountCode();
  const applyBtn = document.querySelectorAll(".apply-discount-button");
  applyBtn.forEach((btn) =>
    btn.addEventListener("click", async (e) => {
      btn.classList.add("loading");
      // try {
      //   await fetch(`/discount/clear`);
      // } catch (err) {
      //   console.log(err);
      // }

      localStorage.setItem("DISCOUNT_CODE", DISCOUNT_CODE);
      await applyBFDiscount(btn);
      btn.classList.remove("loading");
    })
  );
}

function checkDiscountApplied() {
  const DISCOUNT_CODE = getDiscountCode();
  setDiscountButton();
  const discountContainer = document.querySelectorAll(".bf-discount-container");
  const cartPrice = document.querySelectorAll(".cart__price");
  if (localStorage.getItem("DISCOUNT_CODE") === DISCOUNT_CODE) {
    discountContainer.forEach((item) => item.classList.add("discount-applied"));
    cartPrice.forEach((item) => item.classList.add("discount-applied"));
  } else {
    discountContainer.forEach((item) =>
      item.classList.remove("discount-applied")
    );
    cartPrice.forEach((item) => item.classList.remove("discount-applied"));
  }
}

function hasBFEarlyDiscount() {
  const DISCOUNT_CODE = getDiscountCode();
  const cookies = document.cookie.split(";");
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split("=");
    if (name === "discount_code" && value === DISCOUNT_CODE) {
      return true;
    }
  }
  return false;
}

// Flag to prevent infinite loops
if (typeof window.isUpdatingPrice === "undefined") {
  window.isUpdatingPrice = false;
}

function updateMainProductPrice() {
  // Prevent infinite loops
  if (window.isUpdatingPrice) {
    return;
  }

  const discountApplied =
    hasBFEarlyDiscount() ||
    localStorage.getItem("DISCOUNT_CODE") === getDiscountCode();
  const discountRatio = getDiscountRatio();

  if (!discountApplied) {
    // Ensure price is visible when discount is not applied
    const priceContainers = document.querySelectorAll('[id^="price-"]');
    priceContainers.forEach((priceContainer) => {
      const priceContainerDiv = priceContainer.querySelector(".price");
      if (priceContainerDiv) {
        priceContainerDiv.style.opacity = "1";
      }
    });
    return;
  }

  // Set flag to prevent recursive calls
  window.isUpdatingPrice = true;

  // Find all price containers on product pages
  const priceContainers = document.querySelectorAll('[id^="price-"]');

  priceContainers.forEach((priceContainer) => {
    // Skip if already processed
    if (priceContainer.dataset.bfProcessed === "true") {
      return;
    }

    // Skip if product is a gift card
    // Check for gift card indicators on the page
    const isGiftCard =
      document.querySelector(".giftcard-amount-picker") !== null ||
      document.querySelector('[class*="giftcard"]') !== null ||
      window.location.pathname.includes("gift") ||
      document.title.toLowerCase().includes("gift card");

    const isWallet = document.querySelector(".product__buy.dot-wallet") !== null;

    if (isGiftCard || isWallet) {
      // Ensure price is visible for gift cards
      const priceContainerDiv = priceContainer.querySelector(".price");
      if (priceContainerDiv) {
        priceContainerDiv.style.opacity = "1";
      }
      return;
    }

    // Find the active price element - check sale first, then regular
    const priceContainerDiv = priceContainer.querySelector(".price");
    if (!priceContainerDiv) {
      return;
    }

    // Hide price initially to prevent flash, then show smoothly after update
    if (!priceContainer.dataset.bfVisible) {
      priceContainerDiv.style.opacity = "0";
      priceContainerDiv.style.transition = "opacity 0.3s ease-in-out";
    }

    // Check if product is on sale
    const isOnSale = priceContainerDiv.classList.contains("price--on-sale");

    let activePriceElement = null;
    let originalPriceText = "";
    let priceElementParent = null;

    if (isOnSale) {
      // Product is on sale - get the sale price element
      activePriceElement = priceContainerDiv.querySelector(
        ".price__sale .price-item--sale"
      );
      if (activePriceElement) {
        originalPriceText = activePriceElement.textContent.trim();
        priceElementParent = activePriceElement.closest(".price__sale");
      }
    } else {
      // Product is not on sale - get the regular price element
      activePriceElement = priceContainerDiv.querySelector(
        ".price__regular .price-item--regular"
      );
      if (activePriceElement) {
        originalPriceText = activePriceElement.textContent.trim();
        priceElementParent = activePriceElement.closest(".price__regular");
      }
    }

    if (!activePriceElement || !originalPriceText) {
      return;
    }

    // Remove any existing discount spans from the text
    const existingDiscount = activePriceElement.querySelector(
      ".metal-single-discount"
    );
    if (existingDiscount) {
      originalPriceText = originalPriceText
        .replace(existingDiscount.textContent, "")
        .trim();
    }

    // Extract the price number (handle formats like "$40.00", "$40.00&nbsp;", etc.)
    const priceMatch = originalPriceText.match(/\$?([\d,]+\.?\d*)/);
    if (!priceMatch) {
      return;
    }

    const originalPrice = parseFloat(priceMatch[1].replace(/,/g, ""));
    const discountedPrice = (originalPrice * discountRatio).toFixed(2);

    // Store original price in data attribute for restoration
    if (!activePriceElement.dataset.bfOriginalPrice) {
      activePriceElement.dataset.bfOriginalPrice = originalPrice.toFixed(2);
    }

    // Get any suffix (like "/each", "&nbsp;", etc.)
    let suffix = originalPriceText.replace(/\$?[\d,]+\.?\d*/, "").trim();

    // Add space before "/each" if it doesn't already have one
    if (suffix && suffix.startsWith("/") && !suffix.startsWith("/ ")) {
      suffix = " " + suffix;
    }

    // Add non-breaking space after price if there's a suffix
    const priceWithSpace = suffix
      ? `$${discountedPrice}\u00A0${suffix}`
      : `$${discountedPrice}`;
    const originalPriceWithSpace = suffix
      ? `$${originalPrice.toFixed(2)}\u00A0${suffix}`
      : `$${originalPrice.toFixed(2)}`;

    // Check if original price (strikethrough) is already showing
    const existingStrikethrough = priceContainerDiv.querySelector(
      "s.price-item--regular"
    );
    const hasOriginalPriceShowing =
      existingStrikethrough && existingStrikethrough.offsetParent !== null; // Check if visible

    // Only add original price if it's not already showing
    if (!hasOriginalPriceShowing) {
      // Update the price display - show original price crossed off
      if (isOnSale) {
        // Product is on sale - add strikethrough for original price
        let strikethrough = priceElementParent.querySelector(
          "s.price-item--regular"
        );

        if (!strikethrough) {
          // Create strikethrough for original price
          strikethrough = document.createElement("s");
          strikethrough.className = "price-item price-item--regular sale-price";
          strikethrough.style.textDecoration = "line-through";
          strikethrough.style.color = "#6a7c8b";
          strikethrough.style.fontSize = "inherit";
          strikethrough.style.display = "inline";
          priceElementParent.insertBefore(strikethrough, activePriceElement);
        }

        strikethrough.textContent = originalPriceWithSpace;
        // Update the sale price with discounted price
        activePriceElement.textContent = priceWithSpace;
      } else {
        // Product is not on sale - switch to sale structure to show both prices
        const priceContainer = priceContainerDiv.closest(".price__container");
        const priceSaleDiv = priceContainerDiv.querySelector(".price__sale");
        const priceRegularDiv =
          priceContainerDiv.querySelector(".price__regular");

        if (!priceSaleDiv) {
          // Create price__sale structure if it doesn't exist
          const saleDiv = document.createElement("div");
          saleDiv.className = "price__sale";

          // Create strikethrough for original price
          const strikethrough = document.createElement("s");
          strikethrough.className = "price-item price-item--regular sale-price";
          strikethrough.style.textDecoration = "line-through";
          strikethrough.style.color = "#6a7c8b";
          strikethrough.style.fontSize = "inherit";
          strikethrough.style.display = "inline";
          strikethrough.textContent = originalPriceWithSpace;

          // Create sale price element
          const salePriceElement = document.createElement("span");
          salePriceElement.className =
            "price-item price-item--sale price-item--last";
          salePriceElement.textContent = priceWithSpace;

          saleDiv.appendChild(strikethrough);
          saleDiv.appendChild(salePriceElement);

          // Hide regular price and show sale price
          if (priceRegularDiv) {
            priceRegularDiv.style.display = "none";
          }
          priceContainer.appendChild(saleDiv);

          // Add price--on-sale class to show sale styling
          priceContainerDiv.classList.add("price--on-sale");
        } else {
          // Use existing sale structure
          let strikethrough = priceSaleDiv.querySelector(
            "s.price-item--regular"
          );
          const salePriceElement =
            priceSaleDiv.querySelector(".price-item--sale") ||
            activePriceElement;

          if (!strikethrough) {
            strikethrough = document.createElement("s");
            strikethrough.className =
              "price-item price-item--regular sale-price";
            strikethrough.style.textDecoration = "line-through";
            strikethrough.style.color = "#6a7c8b";
            strikethrough.style.fontSize = "inherit";
            strikethrough.style.display = "inline";
            priceSaleDiv.insertBefore(strikethrough, salePriceElement);
          }

          strikethrough.textContent = originalPriceWithSpace;
          salePriceElement.textContent = priceWithSpace;

          // Hide regular price and show sale price
          if (priceRegularDiv) {
            priceRegularDiv.style.display = "none";
          }
          priceSaleDiv.style.display = "";
          priceContainerDiv.classList.add("price--on-sale");
        }
      }
    } else {
      // Original price is already showing - just update the sale price with discount
      activePriceElement.textContent = priceWithSpace;
    }

    // Mark as processed
    priceContainer.dataset.bfProcessed = "true";

    // Show price smoothly after update
    if (priceContainerDiv && !priceContainer.dataset.bfVisible) {
      // Use requestAnimationFrame with a small delay for smooth transition
      requestAnimationFrame(() => {
        setTimeout(() => {
          priceContainerDiv.style.opacity = "1";
          priceContainer.dataset.bfVisible = "true";
        }, 50);
      });
    }
  });

  // Reset flag after a short delay
  setTimeout(() => {
    window.isUpdatingPrice = false;
  }, 100);
}

function updateBFEarlyPricingDiscounts() {
  // Applies active BF20 discount pricing to
  // - Collection cards
  // - Popular Products
  // - Main product page

  const discountApplied = hasBFEarlyDiscount();
  const discountRatio = getDiscountRatio();

  if (discountApplied) {
    const priceElements = document.querySelectorAll(
      ".presale-card-sale-price:not(.dot-wallet), .product-card__produce-price"
    );

    priceElements.forEach((priceElement) => {
      // Check if the element contains only a price (e.g., $30.00)
      if (
        !priceElement.classList.contains("free") &&
        !priceElement.textContent.includes("Starting at") &&
        !priceElement.classList.contains("price-updated")
      ) {
        const currentPriceText = priceElement.textContent.trim();
        const currentPrice = parseFloat(currentPriceText.replace("$", ""));

        priceElement.classList.add("price-updated");
        // x% off
        const discountedPrice = (currentPrice * discountRatio).toFixed(2);

        // update text content
        priceElement.textContent = `$${discountedPrice}`;

        // Check for a sibling presale-card-regular-price element
        const regularPriceElement = priceElement.previousElementSibling;

        if (
          regularPriceElement &&
          regularPriceElement.classList.contains("presale-card-regular-price")
        ) {
          // If it contains '&nbsp;' or '.', replace it with the original price..
          if (
            regularPriceElement.innerHTML.includes("&nbsp;") ||
            regularPriceElement.textContent.trim() === "."
          ) {
            regularPriceElement.textContent = `$${currentPrice.toFixed(2)}`;

            // .. and update styling
            regularPriceElement.style.width = "auto";
            regularPriceElement.style.textDecoration = "line-through";
            regularPriceElement.style.color = ""; // Reset color to default
          } else if (regularPriceElement.classList.contains("empty")) {
            // If it has the 'empty' class (hiding the price), remove it
            regularPriceElement.classList.remove("empty");
          }
        }
      }
    });

    const priceElementsCp = document.querySelectorAll("#product-price-chip-cp");
    priceElementsCp.forEach((priceElement) => {
      const originalPriceElement =
        priceElement.querySelector("span:first-child");
      const discountedPriceElement =
        priceElement.querySelector("span:last-child");
      if (originalPriceElement && discountedPriceElement) {
        const currentPriceText = priceElement.textContent.trim();
        const currentPrice = parseFloat(currentPriceText.replace("$", ""));
        const discountedPrice = (currentPrice * discountRatio).toFixed(2);
        originalPriceElement.textContent = `$${currentPrice.toFixed(2)}`;
        discountedPriceElement.textContent = `$${discountedPrice} /each`;
      }
    });

    // Update main product page price
    updateMainProductPrice();
  } else {
    const priceElements = document.querySelectorAll(".price-updated");
    priceElements.forEach((priceElement) => {
      priceElement.classList.remove("price-updated");
    });

    // Restore original prices on main product page
    const priceContainers = document.querySelectorAll('[id^="price-"]');
    priceContainers.forEach((priceContainer) => {
      if (priceContainer.dataset.bfProcessed === "true") {
        const priceContainerDiv = priceContainer.querySelector(".price");
        const priceSale = priceContainer.querySelector(
          ".price__sale .price-item--sale"
        );
        const priceRegular = priceContainer.querySelector(
          ".price__regular .price-item--regular"
        );
        const priceSaleDiv = priceContainer.querySelector(".price__sale");
        const priceRegularDiv = priceContainer.querySelector(".price__regular");
        const activePriceElement = priceSale || priceRegular;

        if (activePriceElement && activePriceElement.dataset.bfOriginalPrice) {
          const originalPrice = activePriceElement.dataset.bfOriginalPrice;
          const priceText = activePriceElement.textContent.trim();
          const suffix = priceText.replace(/\$?[\d,]+\.?\d*/, "").trim();

          // If we created a sale structure, restore to regular
          if (
            priceSaleDiv &&
            priceRegularDiv &&
            priceRegularDiv.style.display === "none"
          ) {
            // Remove the sale structure we created
            priceSaleDiv.remove();
            // Show regular price
            priceRegularDiv.style.display = "";
            // Remove price--on-sale class
            if (priceContainerDiv) {
              priceContainerDiv.classList.remove("price--on-sale");
            }
            // Update regular price
            if (priceRegular) {
              priceRegular.textContent = `$${originalPrice}${suffix}`;
            }
          } else {
            // Just restore the price text
            activePriceElement.textContent = `$${originalPrice}${suffix}`;

            // Remove strikethrough if it was created by us
            const strikethrough = priceContainer.querySelector(
              ".price__regular s.price-item--regular"
            );
            if (
              strikethrough &&
              !priceContainer.querySelector(".price__sale")
            ) {
              strikethrough.remove();
            }
          }

          delete activePriceElement.dataset.bfOriginalPrice;
        }

        // Ensure price is visible
        if (priceContainerDiv) {
          priceContainerDiv.style.opacity = "1";
        }

        delete priceContainer.dataset.bfProcessed;
        delete priceContainer.dataset.bfVisible;
      }
    });
  }
}

window.addEventListener("DOMContentLoaded", function () {
  const DISCOUNT_CODE = getDiscountCode();

  checkDiscountApplied();

  const hasDiscount = hasBFEarlyDiscount();

  if (hasDiscount) {
    localStorage.setItem("DISCOUNT_CODE", DISCOUNT_CODE);
  }

  // Update main product price on page load if discount is active
  const discountActive =
    localStorage.getItem("DISCOUNT_CODE") === DISCOUNT_CODE || hasDiscount;

  if (discountActive) {
    // Hide price containers immediately to prevent flash
    const priceContainers = document.querySelectorAll('[id^="price-"]');
    priceContainers.forEach((priceContainer) => {
      const priceDiv = priceContainer.querySelector(".price");
      if (priceDiv) {
        priceDiv.style.opacity = "0";
        priceDiv.style.transition = "opacity 0.3s ease-in-out";
      }
    });

    // Call applyBFDiscount which will also update prices
    applyBFDiscount();

    // Call updateMainProductPrice directly after delays to ensure DOM is ready
    // Try multiple times in case DOM isn't fully loaded yet
    const tryUpdatePrice = () => {
      const priceContainers = document.querySelectorAll('[id^="price-"]');
      if (priceContainers.length > 0) {
        updateMainProductPrice();
      }
    };

    // Try immediately, then with delays
    tryUpdatePrice();
    setTimeout(tryUpdatePrice, 100);
    setTimeout(tryUpdatePrice, 300);
    setTimeout(tryUpdatePrice, 600);
  } else {
    // Ensure price is visible when discount is not active
    // Call updateMainProductPrice to ensure visibility
    setTimeout(() => {
      updateMainProductPrice();
    }, 100);
  }

  // Watch for price updates when variants change
  let priceUpdateTimeout = null;

  // Function to set up observers for price containers
  function setupPriceObservers() {
    const priceContainers = document.querySelectorAll('[id^="price-"]');
    priceContainers.forEach((priceContainer) => {
      // Skip if already has observer
      if (priceContainer.dataset.bfObserverSet === "true") {
        return;
      }

      priceContainer.dataset.bfObserverSet = "true";

      const observer = new MutationObserver((mutations) => {
        // Skip if we're currently updating prices ourselves
        if (window.isUpdatingPrice) {
          return;
        }

        // Check if innerHTML actually changed (variant change)
        const hasSignificantChange = mutations.some(
          (mutation) =>
            mutation.type === "childList" &&
            (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)
        );

        if (hasSignificantChange) {
          // Clear existing timeout
          if (priceUpdateTimeout) {
            clearTimeout(priceUpdateTimeout);
          }

          // Only reset processed flag if price actually changed (not from our own update)
          // Check if the price text actually changed by comparing with stored original
          const priceContainerDiv = priceContainer.querySelector(".price");
          if (priceContainerDiv) {
            const priceSale = priceContainerDiv.querySelector(
              ".price__sale .price-item--sale"
            );
            const priceRegular = priceContainerDiv.querySelector(
              ".price__regular .price-item--regular"
            );
            const activePriceElement = priceSale || priceRegular;

            // Only reset if this is a real variant change (price element doesn't have our data attribute)
            if (
              activePriceElement &&
              !activePriceElement.dataset.bfOriginalPrice
            ) {
              delete priceContainer.dataset.bfProcessed;
              delete priceContainer.dataset.bfVisible;

              // Check if discount is applied before hiding
              const discountActive =
                hasBFEarlyDiscount() ||
                localStorage.getItem("DISCOUNT_CODE") === getDiscountCode();

              // Hide price during update to prevent flash (only if discount is active)
              if (priceContainerDiv && discountActive) {
                priceContainerDiv.style.opacity = "0";
              }

              // Reapply discount or ensure visibility after DOM settles
              priceUpdateTimeout = setTimeout(() => {
                updateMainProductPrice();
              }, 150);
            }
          }
        }
      });

      observer.observe(priceContainer, {
        childList: true,
        subtree: true,
      });
    });
  }

  // Set up observers for existing price containers
  setupPriceObservers();

  // Also watch for new price containers being added to the DOM
  const bodyObserver = new MutationObserver(() => {
    setupPriceObservers();
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

if (localStorage.getItem("DISCOUNT_CODE")) {
  const DISCOUNT_CODE = getDiscountCode();
  const DISCOUNT_CODE_COOKIE = document.cookie
    .split("; ")
    .find((row) => row.startsWith("discount_code="))
    ?.split("=")[1];
  if (DISCOUNT_CODE_COOKIE !== DISCOUNT_CODE) {
    localStorage.removeItem("DISCOUNT_CODE");
  }
}
